import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { concatMap, map } from 'rxjs/operators';
import { OrigamiUrlsParams } from '@app/origami-api/constants';
import { SessionService } from '@app/session/session.service';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MainModuleGuard {
  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly sessionService: SessionService,
  ) {}

  canActivate = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const isPasswordManagement =
      state.url.endsWith('/password-management') || state.url.endsWith('/password-management/');

    return this.authService.checkSession().pipe(
      concatMap((authRes) => {
        if (authRes.hasSession && !authRes.registrationMode) {
          if (authRes.info.HasAccessToAnyRoom || isPasswordManagement) {
            return this.sessionService
              .enterDomain()
              .pipe(map(() => ({ loggedIn: true, hasAccessToRooms: authRes.info.HasAccessToAnyRoom })));
          }
          return of({ loggedIn: true, hasAccessToRooms: false });
        }
        return of({ loggedIn: false, hasAccessToRooms: false });
      }),
      map((res) => {
        this.goToAlterUrl({
          loggedIn: res.loggedIn,
          hasAccessToRooms: res.hasAccessToRooms,
          url: route.url.join('/'),
          isPasswordManagement: isPasswordManagement,
        });

        return res.loggedIn && (res.hasAccessToRooms || isPasswordManagement);
      }),
    );
  };

  canDeactivate = () => this.sessionService.leaveDomain().pipe(map(() => true));

  canLoad = (route: Route, segments: UrlSegment[]) =>
    this.authService.checkSession().pipe(
      map((auth) => {
        const loggedIn = auth.hasSession && !auth.registrationMode;

        this.goToAlterUrl({
          loggedIn: loggedIn,
          hasAccessToRooms: loggedIn && auth.info.HasAccessToAnyRoom,
          isPasswordManagement: segments.some((s) => s.path === 'password-management'),
        });

        return loggedIn;
      }),
    );

  private goToAlterUrl(args: {
    loggedIn: boolean;
    hasAccessToRooms: boolean;
    isPasswordManagement?: boolean;
    url?: string;
  }) {
    if (!args.loggedIn) {
      let queryParams;

      if (args.url) {
        queryParams = { [OrigamiUrlsParams.returnRoute]: escape(args.url) };
      } else {
        const routeParts = (unescape(window.location.href) || '').split('#');
        if (routeParts.length > 1) {
          queryParams = { [OrigamiUrlsParams.returnRoute]: escape(routeParts[1]) };
        }
      }
      /*
      const queryParams = args.url
        ? { [OrigamiUrlsParams.returnRoute]: escape(args.url) }
        : {
            [OrigamiUrlsParams.returnRoute]: escape(window.location.href),
          };
      */
      this.router.navigate(['/auth'], { queryParams: queryParams });
    } else if (!args.hasAccessToRooms && !args.isPasswordManagement) {
      this.router.navigate(['/no-access']);
    } else if (args.loggedIn && args.isPasswordManagement) {
      //this.router.navigate(['/ti/domain/password-management']);
    }
  }
}
